import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageLoader, EmptyState } from "@/components/shared";
import { Card } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

export default function Faqs() {
  const { data: faqs, isLoading } = useQuery({
    queryKey: ["author-faqs"],
    queryFn: async () => (await api.get("/author/faqs")).data,
  });

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs uppercase tracking-[0.1em] text-muted-foreground">Help centre</p>
        <p className="text-sm text-muted-foreground mt-1">Answers to common questions about your dashboard, royalties and payouts.</p>
      </div>

      {isLoading ? (
        <PageLoader />
      ) : faqs.length === 0 ? (
        <EmptyState icon={HelpCircle} title="No FAQs yet" desc="Check back soon — help articles will appear here." />
      ) : (
        <Card className="p-2 sm:p-4">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f) => (
              <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${f.id}`}>
                <AccordionTrigger className="text-left font-head font-medium hover:no-underline">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-muted-foreground whitespace-pre-wrap leading-relaxed">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Card>
      )}
    </div>
  );
}
